<template>
  <responsive-modal v-model="show">
    <div class="snow-dialog-content">
      <i :class="icon" v-if="icon" class="fs-60" />

      <slot>
        <div class="my-4">
          {{ text }}
        </div>
      </slot>

      <bp-radio v-if="options.length" v-model="radioValue" :options="options" />

      <div class="snow-submit-buttons w-100 mt-6">
        <snow-button
          size="lg"
          class="order-lg-1"
          :text="buttonText"
          @click="action"
        />
        <snow-button
          size="lg"
          variant="gray"
          :text="secondaryButtonText"
          @click="secondaryAction"
        />
      </div>
    </div>
  </responsive-modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "md"
    },
    variant: {
      type: String,
      default: "primary"
    },
    icon: {
      type: String
    },
    text: {
      type: String
    },
    options: {
      type: Array,
      default: () => []
    },
    buttonText: {
      type: String,
      default: "Confirmar"
    },
    secondaryButtonText: {
      type: String
    }
  },
  data() {
    const radioValue = this.options?.length ? this.options[0].id : "";
    return {
      show: this.value,
      radioValue
    };
  },
  methods: {
    action() {
      this.$emit("action", this.radioValue);
      this.close();
    },
    secondaryAction() {
      this.$emit("secondary-action", this.radioValue);
      this.close();
    },
    close() {
      this.$emit("input", false);
    }
  },
  watch: {
    value(val) {
      this.show = val;
    },
    show(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style lang="scss" scoped>
.snow-dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.close-button {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  font-size: 14px;
  color: rgba(42, 42, 42, 1);
  background-color: rgba(215, 215, 215, 0.48);
  border-radius: 20px;
  transition: unset;
  &:hover {
    background-color: rgba(215, 215, 215, 0.76);
  }
}
</style>
